<template>
	<div class="expandable-text-wrap" @click="toggleByText">
		<v-clamp
			class="expandable-text"
			autoresize
			:max-lines="maxLines"
			ellipsis=""
			@clampchange="toggleReadMore"
		>
			{{ text }}
			<template #after="{ toggle, expanded, clamped }">
				<span
					v-if="expanded || clamped"
					class="toggle-text"
					ref="toggle-text"
					@click="toggle"
				>
					{{ isReadMore ? moreStr : lessStr }}
				</span>
			</template>
		</v-clamp>
	</div>
</template>

<script>
import VClamp from 'vue-clamp'

export default {
	name: 'ExpandableText',

	components: {
		VClamp
	},

	props: {
		moreStr: {
			type: String,
			default: 'read more'
		},
		lessStr: {
			type: String,
			default: 'hide'
		},
		text: {
			type: String,
			required: true
		},
		maxLines: {
			type: Number,
			default: 2
		},
		isWholeArea: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			isReadMore: false
		}
	},

	methods: {
		toggleReadMore(val) {
			this.isReadMore = val
			this.$emit('toggle-read-more', val)
		},

		toggleByText(e) {
			const opener = this.$refs['toggle-text']

			if (!this.isWholeArea || !opener) return

			const { currentTarget } = e
			let { target } = e

			while (target && target !== currentTarget) {
				const isOpener = target.classList.contains('toggle-text')

				if (isOpener) {
					return false
				} else {
					target = target.parentNode

					if (target.classList.contains('expandable-text-wrap')) {
						this.isReadMore = !this.isReadMore
						opener.click()
					}
				}
			}
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.expandable-text .toggle-text {
	margin: 0 0 0 3px;
	color: $soft-purple-bright;
	cursor: pointer;
}
</style>
